import {EditorSelection} from "@codemirror/state";

import {keyNotationValid} from "../decoration/keyNotation.js";
import {changeByTrimmedRange} from "./ranges.js";
import {isSingleCursor, selectedTypesOnlyAllowed, selectedText, selectedTypes} from "../state.js";

export function insertKeyNotation(placeholder) {
  return ({state, dispatch}) => {
    if (canAddKeyNotation({state})) {
      dispatch({...keyNotation(state, placeholder), userEvent: "input.keyNotation"});
    }
  };
}

function keyNotation(state, placeholder) {
  return changeByTrimmedRange(state, ({from, to}) => {
    const {key, inside} = chosenKey(state, {from, to}, placeholder);
    return {
      changes: {from, to, insert: '<kbd>' + key + '</kbd>'},
      range: EditorSelection.cursor(from + 5 + key.length + (inside ? 0 : 6)),
    };
  });
}

function chosenKey(state, range, placeholder) {
  if (range.from === range.to) {
    return {key: placeholder, inside: true};
  }
  return {key: state.sliceDoc(range.from, range.to), inside: false};
}

export function canAddKeyNotation({state}) {
  if (canAddKeyNotationInState(state)) {
    if (isSingleCursor(state)) {
      return true;
    }
    return keyNotationValid(selectedText(state).trim());
  }
  return false;
}

function canAddKeyNotationInState(state) {
  if (!onlyKeyNotationAllowedTypes(state)) {
    return false;
  }
  const types = selectedTypes(state);
  if (types.has('HeaderMark')) {
    return types.has('ATXHeading1') || types.has('SetextHeading1');
  }
  return canAddKeyNotationInTable(types, state);
}

function onlyKeyNotationAllowedTypes(state) {
  return selectedTypesOnlyAllowed(state, [
    'Paragraph', 'Blockquote',
    'StrongEmphasis', 'Emphasis', 'Strikethrough',
    'Table', 'TableRow', 'TableHeader', 'TableCell', 'TableDelimiter',
    'BulletList', 'OrderedList', 'ListItem',
    'ATXHeading1', 'ATXHeading2', 'ATXHeading3', 'ATXHeading4', 'ATXHeading5', 'ATXHeading6', 'HeaderMark',
    'SetextHeading1', 'SetextHeading2'
  ]);
}

function canAddKeyNotationInTable(types, state) {
  if (!types.has('Table')) {
    return true;
  }
  if (types.has('TableRow')) {
    return true;
  }
  return types.has('TableHeader') && isNotAfterLastDelimiter(state);
}

function isNotAfterLastDelimiter(state) {
  return onlyWhitespaceAfterDelimiter(lineAtPosition(state, state.selection.main.from));
}

function onlyWhitespaceAfterDelimiter(line) {
  return line.slice(line.lastIndexOf('|')).trimRight() !== '|';
}

function lineAtPosition(state, position) {
  const {from, to} = state.doc.lineAt(position);
  return state.sliceDoc(from, to);
}
